import { render, staticRenderFns } from "./FaceCrux.vue?vue&type=template&id=101b015b&scoped=true"
import script from "./FaceCrux.vue?vue&type=script&lang=js"
export * from "./FaceCrux.vue?vue&type=script&lang=js"
import style0 from "./FaceCrux.vue?vue&type=style&index=0&id=101b015b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101b015b",
  null
  
)

export default component.exports